import React from 'react';
import styled from 'styled-components';

import colors from '../../styled-components/palette';

const Colors = Object.freeze({
  wrapperBackground: colors.yellowwinamax900,
  textColor: colors.yellowwinamax350,
});

const Wrapper = styled.div`
  padding: 0.15em 1em;
  border-radius: 7px;
  font-size: 0.72em;
  background-color: ${Colors.wrapperBackground};
  color: ${Colors.textColor};
`;

type BetCurrentTotalTagProps = {
  className?: string;
  currentTotal: number;
};

const BetCurrentTotalTag = ({ className = '', currentTotal }: BetCurrentTotalTagProps) => {
  return <Wrapper className={className}>{currentTotal}</Wrapper>;
};

export default BetCurrentTotalTag;
